import Vue from 'vue'
import CONFIG from './../../config.js'

let actions = {
  loadPayment (context, params) {
    context.commit('addLog', { request: 'payments' })

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(CONFIG.getEndpoint('payments'), {
          params: params,
          withCredentials: true,
          xsrfCookieName: 'SSO_TOKEN'
        })
        .then(response => {
          context.commit('PAYMENT_APP', response.data)
          context.commit('removeLog', { request: 'payments' })
          resolve()
        })
        .catch(() => {
          context.commit('removeLog', { request: 'payments' })
          reject()
        })
    })
  },

  makePayment (context, params) {
    context.commit('addLog', { request: 'makePayment' })
    Vue.axios
      .post(CONFIG.getEndpoint('makePayment'), params, {
        withCredentials: true,
        xsrfCookieName: 'SSO_TOKEN'
      })
      .then(response => {
        context.commit('removeLog', { request: 'makePayment' })
        window.open(response.data.paymentUrl, '_self')
      })
      .catch(() => {
        context.commit('removeLog', { request: 'makePayment' })
      })
  },

  loyaltyPoints (context, params) {
    context.commit('addLog', { request: 'loyaltyPoints' })
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(CONFIG.getEndpoint('loyaltyPoints'), params, {
          withCredentials: true,
          xsrfCookieName: 'SSO_TOKEN'
        })
        .then(() => {
          context.commit('removeLog', { request: 'loyaltyPoints' })
          resolve()
        })
        .catch(() => {
          context.commit('removeLog', { request: 'loyaltyPoints' })
          reject()
        })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/payments/actions.js